export const IntefrationLogConstant = {
    API: 'IntegrationLog',
    API_ILP: 'IntegrationLogProcess'
}

export const IntefrationLogAPIConstant = {
    GET_INTEGRATION_LOG: IntefrationLogConstant.API + '/GetIntegrationLogs',
    GET_INTEGRATION_LOG_DETAILS: IntefrationLogConstant.API + '/GetIntegrationLogDetails',//?requestId=1
    GET_PRODUCT_VARIANT_BY_ID: IntefrationLogConstant.API + '/GetProductVariantById',//?requestId=1
    GET_RAW_MATERIAL_BY_ID: IntefrationLogConstant.API + '/GetRawMaterialById',//?requestId=1
    GET_GENERIC_GROUP_BY_ID: IntefrationLogConstant.API + '/GetGenericGroupById',// ?requestId=1
    RE_PROCESS: IntefrationLogConstant.API + '/ReProcess',

    PROCESS_CONTENT: IntefrationLogConstant.API_ILP + '/ProcessContent',
    MATERIAL_MASTER: IntefrationLogConstant.API_ILP + '/MaterialMaster',
    GET_PROCESS_CONTENT_DETAILS_BY_ID: IntefrationLogConstant.API_ILP + '/GetProcessContentDetailsById',//?id=0

} 